import React from 'react';

import { Spin, Table, Tooltip } from 'antd';

import MyIcon from 'components/Icon';
import Truncate from 'components/Truncate';
import ProductStatusTag from 'scenes/Producer/Product/MyProducts/components/ProductStatusTag';
import { TableActionButton } from 'v2/components/Shared/TableActionButton';
import { useIrregularProductVariations } from 'v2/hooks/useIrregularProductVariations';
import type { IProduct } from 'v2/interfaces/product';

type DataChildrenProps = {
  product: IProduct;
  onClickOptions: (product: IProduct, activatedChildren: number) => void;
};

const DataChildren = ({ product, onClickOptions }: DataChildrenProps) => {
  const productVariationsQuery = useIrregularProductVariations(product.id, {
    enabled: true
  });

  const columns = [
    {
      title: 'Produto',
      key: 'product',
      render: (_: any, variation: any) => (
        <div className='flex justify-start max-md:flex-col'>
          <div className='border-(--uizz-antd-color-border) bg-(--uizz-antd-color-fill-alter) relative mr-3 size-12.5 overflow-hidden rounded-sm border'>
            {variation.image ? (
              <img src={variation.image} alt='' className='absolute inset-0 size-full object-cover' />
            ) : null}
          </div>
          <div>
            <div
              className='text-content-subtitle overflow-hidden pr-4 text-ellipsis'
              title={variation.title || 'Desconhecido'}
            >
              <Truncate count={80} final='...'>
                {variation.title || 'Desconhecido'}
              </Truncate>
            </div>
            {!variation.has_children && (
              <div>
                <ProductStatusTag status={variation.moderation_status} productType={variation.type} />
                {variation.charge_type === 'A' && (
                  <Tooltip title='Recorrência' placement='top'>
                    <div className='w-3.75'>
                      <MyIcon className='icon' name='icon-assinaturas' />
                    </div>
                  </Tooltip>
                )}
              </div>
            )}
          </div>
        </div>
      )
    },
    {
      title: '',
      key: 'actions',
      align: 'right' as const,
      render: (_: any, variation: any) => (
        <TableActionButton onClick={() => onClickOptions(variation, productVariationsQuery.data?.length)} />
      )
    }
  ];

  return (
    <>
      {productVariationsQuery.isLoading && (
        <div className='flex justify-center py-4'>
          <Spin size='small' />
        </div>
      )}
      <Table size='small' dataSource={productVariationsQuery.data} columns={columns} rowKey='id' pagination={false} />
    </>
  );
};

export default DataChildren;
